import styled from "styled-components";
import { C, MQ, TYPE } from "Components/WebsiteTheme/WebsiteTheme.style";

/* Testimonials page: cream quote cards, same colours and type as the testimonial strip on Home and About */
export const TestimonialsPageContainer = styled.section`
	.tp_grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 28px;
		margin-top: 48px;

		${MQ.TABLET} {
			grid-template-columns: 1fr;
			gap: 20px;
			margin-top: 36px;
		}
	}

	.tp_card {
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 24px;
		padding: 36px 32px 32px;
		border: 1px solid ${C.creamLine};
		border-radius: 20px;
		background: ${C.cream};

		${MQ.PHONE} {
			padding: 28px 20px 24px;
		}
	}

	.tp_mark {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 44px;
		height: 44px;
		border-radius: 50%;
		background: ${C.gold};
		color: ${C.navy};

		svg {
			width: 20px;
			height: 20px;
		}
	}

	.tp_quote {
		flex: 1;
		margin: 0;
		color: ${C.navy};
		font-size: 17px;
		font-style: italic;
		font-weight: 500;
		line-height: 1.6;
		text-wrap: pretty;

		${MQ.PHONE} {
			font-size: 16px;
		}
	}

	.tp_author {
		display: flex;
		align-items: center;
		gap: 14px;
		padding-top: 20px;
		border-top: 1px solid ${C.creamLine};
	}

	.tp_avatar {
		display: inline-flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		width: 56px;
		height: 56px;
		border: 3px solid #fff;
		border-radius: 50%;
		background: linear-gradient(135deg, ${C.blue} 0%, ${C.navy} 100%);
		box-shadow: ${C.cardShadow};
		color: #fff;
		font-size: 18px;
		font-weight: 700;
		letter-spacing: 0.5px;
	}

	.tp_name {
		color: ${C.blue};
		${TYPE.cardTitle}
		font-size: 16px;
	}
`;
